import * as React from 'react'

import {
  Box,
  Icon,
  ProgressBar,
  type SortDirection,
  Table,
  Text,
} from '@factorialco/deprecated-design-system'
import orderBy from 'lodash/orderBy'

import createMemo from 'modules/core/hooks/createMemo'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import EmployeeLabel from 'modules/reviews/components/EmployeeLabel'
import { ReviewersList } from 'modules/reviews/components/Participants/Table/Body'
import type { Review as ReviewType } from 'modules/reviews/lib/types'
import type Review from 'modules/reviews/store/models/v2/Review'

const useFilter = createMemo((reviews: ReviewType[], search: string) =>
  reviews.filter(({ target }) => target.matchesFullName(search))
)
interface Props {
  form: Review
  search: string
  reviews: ReviewType[]
  loading: boolean
  direction: SortDirection
}

export default function Body({ form, search, reviews, loading, direction }: Props) {
  const { navigation } = useNavigation()

  const filteredReviews = useFilter(reviews, search)
  const sortedReviews = orderBy(filteredReviews, (review) => review?.target.fullName(), [direction])

  if (loading)
    return (
      <Table.Body>
        <Table.Loading colSpan={10} />
      </Table.Body>
    )

  return (
    <Table.Body>
      {Boolean(!reviews.length) && (
        <Table.Blank colSpan={10} text={i18n.t('surveys.review.reviews.table.body.no_reviews')} />
      )}
      {Boolean(reviews.length) &&
        sortedReviews.map(({ target, reviewers, completion, total, endDate }) => {
          const route = navigation.performance.reviews.id.reviews.targetReviewers.fullPath({
            id: form.attributes.id,
            user_id: target.id,
          })

          return (
            <Table.Row.Router key={target.id} to={route}>
              <Table.Cell colSpan={3}>
                <EmployeeLabel user={target} />
              </Table.Cell>
              {!form.isAnonymous && (
                <Table.Cell colSpan={2}>
                  <ReviewersList reviewers={reviewers} />
                </Table.Cell>
              )}
              <Table.Cell colSpan={2}>
                <ProgressBar showLabel amount={completion} total={total} />
              </Table.Cell>
              <Table.Cell colSpan={2}>
                <Text.Normal>{endDate ? dateToString(endDate, 'ui') : '-'}</Text.Normal>
              </Table.Cell>
              <Table.Cell>
                <Box alignItems="flexEnd" aria-label="Answer review">
                  <Icon.Medium icon="arrow-right" />
                </Box>
              </Table.Cell>
            </Table.Row.Router>
          )
        })}
    </Table.Body>
  )
}
